/**
 * WOD3D product lightbox — robust open handler.
 * Uses capture-phase delegation so it works even if modal-opener lifecycle fails.
 */
(function () {
  function activateMedia(modal, mediaId) {
    if (!modal || !mediaId) return;
    modal.querySelectorAll('[data-media-id]').forEach((el) => {
      el.classList.toggle('active', el.getAttribute('data-media-id') === mediaId);
    });
    const active = modal.querySelector(`[data-media-id="${mediaId}"]`);
    if (active) {
      try {
        active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      } catch (_) {}
    }
  }

  function openLightbox(toggle) {
    if (!(toggle instanceof HTMLElement)) return;
    if (toggle.classList.contains('product__media-zoom-none')) return;

    const opener = toggle.closest('modal-opener');
    const selector = opener?.getAttribute('data-modal');
    if (!selector) return;

    const modal = document.querySelector(selector);
    if (!modal) return;

    const mediaId = toggle.getAttribute('data-media-id');

    if (typeof modal.show === 'function') {
      modal.show(toggle);
      return;
    }

    // Fallback if product-modal custom element failed to upgrade
    modal.openedBy = toggle;
    modal.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    activateMedia(modal, mediaId);
  }

  document.addEventListener(
    'click',
    (event) => {
      const toggle = event.target.closest(
        'button.product__media-zoom-lightbox, button.product__media-zoom-hover'
      );
      if (!toggle) return;
      if (toggle.closest('quick-add-modal')) return;

      // In-frame magnify handles touch/mobile for hover zoom (drag to pan).
      if (
        toggle.classList.contains('product__media-zoom-hover') &&
        window.matchMedia('(hover: none), (pointer: coarse), (max-width: 749px)').matches
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      openLightbox(toggle);
    },
    true
  );
})();
